(() => {
  const giftSVG = document.currentScript?.dataset.giftSvg;
  const launcherCSS = document.currentScript?.dataset.launcherCss;
  const giftIcon = giftSVG ? 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(giftSVG) : '';
  const frames = new WeakSet();
  const documents = new WeakSet();
  const styleLauncher = frame => {
    let frameDocument;
    try { frameDocument = frame.contentDocument; } catch (_) { return; }
    if (!frameDocument || documents.has(frameDocument) || !giftIcon) return;
    documents.add(frameDocument);
    const updateImage = () => {
      if (launcherCSS && frameDocument.head && !frameDocument.getElementById('MasSmileLauncherStyle')) {
        const style = frameDocument.createElement('style');
        style.id = 'MasSmileLauncherStyle';
        style.textContent = launcherCSS;
        frameDocument.head.appendChild(style);
      }
      const image = frameDocument.querySelector('.launcher-button img.launcher-image');
      if (image && image.getAttribute('src') !== giftIcon) image.setAttribute('src', giftIcon);
    };
    new MutationObserver(updateImage).observe(frameDocument, { childList: true, subtree: true, attributes: true, attributeFilter: ['src'] });
    updateImage();
  };
  const connectLauncher = () => {
    document.querySelectorAll('iframe.smile-launcher-frame').forEach(frame => {
      if (!frames.has(frame)) {
        frames.add(frame);
        frame.addEventListener('load', () => styleLauncher(frame));
      }
      styleLauncher(frame);
    });
  };
  new MutationObserver(records => {
    if (records.some(record => Array.from(record.addedNodes).some(node => node.nodeType === 1 &&
      (node.matches('iframe.smile-launcher-frame') || node.querySelector('iframe.smile-launcher-frame'))))) connectLauncher();
  }).observe(document.body, { childList: true, subtree: true });
  connectLauncher();

  let opening = false;
  let request = 0;
  const panelVisible = () => {
    const panel = document.querySelector('.smile-panel-frame-container');
    if (!panel) return false;
    const box = panel.getBoundingClientRect();
    const style = getComputedStyle(panel);
    return box.width > 0 && box.height > 0 && style.visibility !== 'hidden' && style.display !== 'none' && Number(style.opacity) !== 0;
  };
  const waitForPanel = ticket => new Promise(resolve => {
    const deadline = Date.now() + 10000;
    const check = () => {
      if (ticket !== request || Date.now() >= deadline) return resolve(false);
      if (panelVisible()) return resolve(true);
      setTimeout(check, 100);
    };
    check();
  });
  document.addEventListener('click', async event => {
    const link = event.target.closest?.('[data-mas-rewards-link]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    if (opening) return;
    opening = true;
    const ticket = ++request;
    link.setAttribute('aria-busy', 'true');
    try {
      const drawer = link.closest('hdt-drawer[open]');
      if (typeof drawer?.closeDialog === 'function') await drawer.closeDialog(false);
      const previousURL = location.href;
      if (location.hash !== '#smile-home') location.hash = 'smile-home';
      else window.dispatchEvent(new HashChangeEvent('hashchange', { oldURL: previousURL, newURL: previousURL }));
      Promise.resolve(window.MASApps?.loadRewards()).then(async () => {
        if (typeof window.SmileUI?.ready !== 'function' || typeof window.SmileUI?.openPanel !== 'function') return;
        await window.SmileUI.ready();
        if (opening && ticket === request && !panelVisible()) window.SmileUI.openPanel();
      }).catch(() => {});
      if (!(await waitForPanel(ticket))) location.assign('/pages/rewards#smile-home');
    } catch (_) {
      location.assign('/pages/rewards#smile-home');
    } finally {
      opening = false;
      request += 1;
      link.removeAttribute('aria-busy');
    }
  });
})();
